import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts

import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import Index from "views/Index.js";
import Iso from "views/Iso";
import IsoB from "views/IsoB";
import Isoo from "views/Isoo";
import Gallery from "views/Gallery";
import Projecthighlight from "views/Projecthighlight";
import Location from "views/Location";
import Unit2d from "views/Unit2d";
import Goldenwillows from "views/Goldenwillows";
import Tower from "views/Tower";
import Detail from "views/Detail";
import Amenities from "views/Amenities";
import Disclaimer from "views/disclaimer";
import Walkthrough from "views/Walkthrough";
import DetailB from "views/DetailB";
import Unitb2d from "views/Unitb2d";


ReactDOM.render(
  <BrowserRouter>
    <Switch>
      {/* add routes with layouts */}
      <Route path="/admin" component={Admin} />
      <Route path="/auth" component={Auth} />
      {/* add routes without layouts */}
      <Route path="/landing" exact component={Landing} />
      <Route path="/profile" exact component={Profile} />
      <Route path="/" exact component={Index} />
      <Route path="/iso-3d/:floor/:plan/:unit" exact component={Iso} />
      <Route path="/iso" exact component={Isoo} />
      <Route path="/2d-unit/:floor/:plan/:unit" exact component={Unit2d} />
      <Route path="/2d-unit-b/:floor/:plan/:unit" exact component={Unitb2d} />
      <Route path="/gallery" exact component={Gallery} />
      <Route path="/project-highlight" exact component={Projecthighlight} />
      <Route path="/location" exact component={Location} />
      <Route path="/master-plans" exact component={Goldenwillows} />
      <Route path="/tower" exact component={Tower}/>
      <Route path="/detail/:floor/:plan" exact component={Detail}/>
      <Route path="/detail-b/:floor/:plan" exact component={DetailB}/>
      <Route path="/iso-b-3d/:floor/:plan/:unit" exact component={IsoB} />
      <Route path="/amenities" exact component={Amenities}/>
      <Route path="/disclaimer" exact component={Disclaimer}/>
      <Route path="/walkthrough" exact component={Walkthrough}/>
      {/* <Route path="/home" exact component={IndexPages}/> */}
      {/* add redirect for first page */}
      <Redirect from="*" to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
